import { memo, useMemo } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'
import { checkFieldError } from 'helpers/form'
import { IInputProps, Input } from 'shared/components/Input'
import { IInputPropsGenericExtend } from 'shared/ui/InputBase'

import { useIsEqualWithFormat } from './hooks'

interface IFieldTextInputProps {
  maxLength?: number
}

interface IProps
  extends Pick<UseFieldConfig<string>, 'format' | 'formatOnBlur' | 'validate'>,
    Omit<IInputProps<IInputPropsGenericExtend>, 'name' | 'value' | 'defaultValue'>,
    IFieldTextInputProps {
  name: string
  testId?: string
}

export const FieldText = memo(function FieldText({
  name,
  format,
  formatOnBlur,
  validate,
  maxLength,
  testId,
  ...props
}: IProps) {
  const isEqual = useIsEqualWithFormat(format)
  const { input, meta } = useField<string>(name, {
    validate,
    format,
    formatOnBlur,
    isEqual,
    parse: (value?: string) => value || ''
  })

  const inputProps = useMemo<IFieldTextInputProps>(() => ({ maxLength }), [maxLength])
  const error = checkFieldError(meta)

  return (
    <Input
      {...props}
      error={error}
      inputProps={inputProps}
      name={name}
      onBlur={input.onBlur}
      onChange={input.onChange}
      onFocus={input.onFocus}
      testId={testId}
      value={input.value || ''}
    />
  )
})
